var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseApiClient from '@/plugins/apis/v2/base-api-client';
var DailyReportApiClient = /** @class */ (function (_super) {
    __extends(DailyReportApiClient, _super);
    function DailyReportApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DailyReportApiClient.prototype.basePath = function (_a) {
        var projectId = _a.projectId, scheduleId = _a.scheduleId;
        var companyId = this.companyId;
        return "/companies/" + companyId + "/projects/" + projectId + "/schedules/" + scheduleId + "/daily_reports";
    };
    DailyReportApiClient.prototype.index = function (projectId, scheduleId, smallProcessId) {
        var client = this.client;
        var url = this.basePath({ projectId: projectId, scheduleId: scheduleId });
        var params = {
            small_process_id: smallProcessId
        };
        return client.get(url, { params: params });
    };
    DailyReportApiClient.prototype.show = function (projectId, scheduleId, dailyReportId) {
        var client = this.client;
        var url = this.basePath({ projectId: projectId, scheduleId: scheduleId }) + "/" + dailyReportId;
        return client.get(url);
    };
    DailyReportApiClient.prototype.create = function (projectId, scheduleId, smallProcessId, params, notice) {
        if (notice === void 0) { notice = false; }
        var requestAction = this.requestAction;
        var url = this.basePath({ projectId: projectId, scheduleId: scheduleId });
        return requestAction({
            url: url,
            data: {
                small_process_id: smallProcessId,
                daily_report: params
            },
            resourceName: 'daily_report',
            actionName: 'POST',
            notice: notice
        });
    };
    DailyReportApiClient.prototype.update = function (payload) {
        var requestAction = this.requestAction;
        var baseUrl = this.basePath({ projectId: payload.projectId, scheduleId: payload.scheduleId });
        var url = baseUrl + "/" + payload.id;
        var dailyReportParams = {
            body: payload.body,
            draft: payload.draft ? '1' : '0',
            construction_date: payload.construction_date
        };
        if (payload.before_image_id) {
            dailyReportParams.before_image_id = payload.before_image_id;
        }
        if (payload.after_image_id) {
            dailyReportParams.after_image_id = payload.after_image_id;
        }
        if (Number.isInteger(payload.progress)) {
            dailyReportParams.progress = payload.progress;
        }
        return requestAction({
            url: url,
            method: 'put',
            data: {
                small_process_id: payload.smallProcessId,
                daily_report: dailyReportParams
            },
            resourceName: 'update_daily_report',
            actionName: 'OTHER',
            notice: !payload.draft
        });
    };
    DailyReportApiClient.prototype.delete = function (projectId, scheduleId, smallProcessId, id) {
        var requestAction = this.requestAction;
        var url = this.basePath({ projectId: projectId, scheduleId: scheduleId }) + "/" + id;
        var params = {
            small_process_id: smallProcessId
        };
        return requestAction({
            url: url,
            method: 'delete',
            params: params,
            resourceName: 'daily_report',
            actionName: 'DELETE',
            notice: true
        });
    };
    DailyReportApiClient.prototype.getPreReport = function (_a) {
        var projectId = _a.projectId, scheduleId = _a.scheduleId, smallProcessId = _a.smallProcessId, constructionDate = _a.constructionDate;
        var client = this.client;
        var url = this.basePath({ projectId: projectId, scheduleId: scheduleId }) + "/pre_report";
        var params = {
            small_process_id: smallProcessId,
            construction_date: constructionDate
        };
        return client.get(url, { params: params });
    };
    return DailyReportApiClient;
}(BaseApiClient));
export default new DailyReportApiClient();
